<div [hidden]="!isLoading" class="spinner">
  <div class="sk-spinner sk-spinner-pulse"></div>
</div>

<div class="modal-header mb-10">
  <div class="modal-title">
    <h3 *ngIf="header" class="d-inline-block">{{header}}</h3>
    <h3 *ngIf="!header" class="d-inline-block">Enter the title</h3>
    <button type="button" class="btn-close" (click)="onCancelClick()">
      <span class="icon-close"></span>
    </button>
  </div>
</div>

<div class="modal-body">
  <form [formGroup]="titleForm" class="pos-relative form">
    <div class="form-group">
      <label *ngIf="titleLabel">{{titleLabel}} <span class="text-danger">*</span></label>
      <label *ngIf="!titleLabel">Title <span class="text-danger">*</span></label>
      <input [(ngModel)]="titleModel.title" formControlName="title" (keyup.enter)="onEnterKeyPress()" type="text" class="form-control my-15">
      <div *ngIf="isDuplicate" class="input-errors">
        <span class="help-block m-b-none text-danger">The template name is already taken.</span>
      </div>
      <input-errors [control]="titleForm.controls.title" [service]="validationService"></input-errors>
    </div>
  </form>
</div>

<div class="modal-footer pt-15 d-flex justify-content-between align-items-center">
  <a role="button" class="btn btn-outline-dark" (click)="onCancelClick()">Cancel</a>
  <button [disabled]="!isTitleFormValid()" class="btn btn-primary" type="submit" (click)="onSubmitClick()">Submit</button>
</div>
